import { AreaType } from 'types/area';

function toLatLng(paths) {
  return paths.map((path) => [path.x, path.y]);
}

export async function getAreas(): Promise<AreaType[]> {
  return fetch(`${process.env.SERVER_URL}/areas`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .then((res: AreaType[]) => {
      return res.map((area) => ({
        id: area.id,
        name: area.name,
        icon: area.icon,
        coordinates: toLatLng(area.coordinates),
        description: area.description,
        block: Boolean(area.block),
      }));
    })
    .catch((err) => {
      console.log('Fetch areas error', err);
      return [];
    });
}

export async function addArea(area: AreaType) {
  return fetch(`${process.env.SERVER_URL}/areas`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(area),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status && res.status !== 200) {
        throw 'Add area failed';
      }
    })
    .catch((err) => {
      console.log('Add area error', err);
      throw err;
    });
}

export async function changeArea(area: AreaType) {
  const { id } = area;
  return fetch(`${process.env.SERVER_URL}/areas/${id}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(area),
  }).then((res) => {
    if (res.status !== 200) {
      throw 'Change area failed';
    }
  });
}

export async function deleteArea(id: string) {
  return fetch(`${process.env.SERVER_URL}/areas/${id}`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status && res.status !== 200) {
        throw 'Delete area failed';
      }
    })
    .catch((err) => {
      console.log('Delete area error', err);
      throw err;
    });
}
